export default "__VITE_ASSET__bvbL1piJ__"